<template lang="pug" src="./template.pug">
</template>
<style scoped lang="scss" src="./style.scss"></style>

<script>
import bus from 'utils/js/bus';
let self;
export default {
    name: "Header",
    props: {
        msg: String,
    },
    data(){
        return {
            toggle:false
        }
    },
    methods: {
        buildListeners() {
			bus.$on('showNav', show=>{
				self.toggle = show;
			})

            $(window).bind('resize', onResizeHandler);
            onResizeHandler();

            function onResizeHandler(){
                $('.wrapper').css({'padding-top':$('header').height()});
            }
        },
    },
    mounted() {
        self = this;
        this.buildListeners();
    },
    watch:{
        'toggle'(){
            if (this.toggle) {
                $('header nav').stop().slideDown(400);
            } else {
                $('header nav').stop().slideUp(400);
            }
        }
    }
};
</script>